// 
// -----------------------------------------------------------------------------
(function ($newsPop) {
	if ($newsPop.length === 0) {return false;}

	var NewsletterCookie = Cookies.get('close');
	var $newsLetterClose = $('.newsletter-close');

	function newsToggle(){
		$newsPop.removeClass('out');
	}

	if ( NewsletterCookie !== 'true') {
	
		setTimeout(function(){
			$newsPop.addClass('out');
		}, 2000);
	
	}


	$newsLetterClose.on('click', function(){

		Cookies.set('close', true, { expires: 1 });
		newsToggle();

	});

})($( '.newsletter-pop' ));


